// src/components/EditClient.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Typography, Box, Paper, Grid, TextField, Button, MenuItem } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
const API_URL = process.env.REACT_APP_API_URL || '';

// Funkcja konwertująca datę na format "YYYY-MM-DD"
const convertDateToInputFormat = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const EditClient = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [client, setClient] = useState(null);
    const [form, setForm] = useState({
        company_name: '',
        contact_person: '',
        email: '',
        phone: '',
        service_type: '',
        mrr: '',
        status: '',
        start_date: '',
        next_invoice_date: ''
    });

    useEffect(() => {
        const fetchClient = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/clients/${id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setClient(response.data);
                setForm({
                    company_name: response.data.company_name,
                    contact_person: response.data.contact_person,
                    email: response.data.email,
                    phone: response.data.phone,
                    service_type: response.data.service_type,
                    mrr: response.data.mrr,
                    status: response.data.status,
                    start_date: convertDateToInputFormat(response.data.start_date),
                    next_invoice_date: convertDateToInputFormat(response.data.next_invoice_date)
                });
            } catch (error) {
                console.error('Error fetching client:', error);
            }
        };
        fetchClient();
    }, [id, token]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.put(`${API_URL}/api/clients/${id}`, form, {
                headers: { Authorization: `Bearer ${token}` }
            });
            navigate('/clients');
        } catch (error) {
            console.error('Error updating client:', error);
        }
    };

    if (!client) {
        return <Typography>Ładowanie danych...</Typography>;
    }

    return (
        <Container maxWidth="lg">
            <Box sx={{ mt: 4 }}>
                <Paper sx={{ p: 2 }}>
                    <Typography variant="h4" gutterBottom>Edycja klienta</Typography>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Nazwa firmy" name="company_name" value={form.company_name} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Osoba kontaktowa" name="contact_person" value={form.contact_person} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Email" name="email" type="email" value={form.email} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Telefon" name="phone" value={form.phone} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Typ usługi"
                                    name="service_type"
                                    value={form.service_type}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="aiteams">aiteams</MenuItem>
                                    <MenuItem value="pricemonit">pricemonit</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="MRR" name="mrr" value={form.mrr} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Status"
                                    name="status"
                                    value={form.status}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="active">active</MenuItem>
                                    <MenuItem value="pending">pending</MenuItem>
                                    <MenuItem value="inactive">inactive</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Data rozpoczęcia" name="start_date" type="date" value={form.start_date} onChange={handleChange} InputLabelProps={{ shrink: true }} required />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Data następnej faktury" name="next_invoice_date" type="date" value={form.next_invoice_date} onChange={handleChange} InputLabelProps={{ shrink: true }} required />
                            </Grid>
                            <Grid item xs={12}>
                                <Button type="submit" variant="contained" color="primary">
                                    Zapisz zmiany
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
};

export default EditClient;